var React = require('react');

function EveryDayIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m4.9 8.12492v-1.625c0-.75833-.47667-1.35417-1.08333-1.35417h-1.73334c-.60666 0-1.08333.59584-1.08333 1.35417v1.625h13m-13-7.04167v13.00005m13-9.75005v9.75005m-13-3.25h13","stroke":"#000","strokeLinecap":"square","strokeMiterlimit":"10"}));
}

EveryDayIconInline.defaultProps = {"fill":"none","height":"15","viewBox":"0 0 15 15","width":"15"};

module.exports = EveryDayIconInline;

EveryDayIconInline.default = EveryDayIconInline;
